import React, { Component } from 'react'
import {connect} from 'react-redux';
import   { Menu, Icon, Button, Sidebar,Popup, Label, Form, Modal, a} from 'semantic-ui-react';
import '../App.css'
// import {render} from 'react-dom';
import { HashRouter as Router, Route, Switch, Link } from 'react-router-dom';

import 'semantic-ui-css/semantic.min.css';
import '../App.css';
import '../index.css';
import Login from '../components/login'
import Dashboard from './dashboard';
import Whoops from './Whoops'
import About from './about';
import Account from './account'
import NetworkSettings from './networksettings';
import firebase from '../firebase';
import {bindActionCreators} from 'redux';
import * as stuffActions from '../actions/actions';
import {ToastContainer, toast} from 'react-toastify';
var moment = require('moment');

/*
    This is the the most important compoenet.
    In addition to rendering the main menu and side nav, it also includes the routes to all other compoenents. 
    If you add a new page to this project, you'll need to add the link and route for the said page in this compoenet. See line 234 - 240 below.
    If you need to include the new page in side nave menu. See line 188 onwards
*/

class MainMenu extends Component {
    constructor(props){
        super(props)
        this.state = { visible: false, userName:'Log In' }

        this.checkAuthStatus = this.checkAuthStatus.bind(this);
        this.handleSignOut = this.handleSignOut.bind(this);
        this.submitBug  = this.submitBug.bind(this);

    }
    
        
  
  toggleVisibility = () => this.setState({ visible: !this.state.visible })

//   componentWillReceiveProps(props){
//     this.setState({userName: props.userName})
//   }

submitBug(e){
    let value = document.getElementById("bugReport").value;
    value = String(value);
    if(value.length < 1){
        toast.warn("Please provide some detail!")
    } else{
        this.props.stuffActions.reportBug(value, this.props.userId)
    }
   
}
handleSignOut(e){
    e.preventDefault();
    firebase.fireAuth.signOut();
    window.location.reload(); //reload the page so it clear all the user data

}

checkAuthStatus(){
    this.authListener = firebase.fireAuth.onAuthStateChanged((user) => {
     if (user){
         this.setState({
             userName: user.displayName,
             userEmail:user.email,
             authenticated: true,
             id: user.uid
         });
          this.props.stuffActions.updateAuth(this.state.userName, this.state.id, this.state.userEmail);
        } else{
         this.setState({
             email: null,
             password: null,
             userEmail:null,
             initName:null,
             userName : 'Log In',
             error:null,
             authenticated:false,
             agreedTerms: null,
             showError:null,
             
         })
          this.props.stuffActions.updateAuthLogOut(this.state.userName);
        } 
    });
 }


// componentWillMount(){
//     this.checkAuthStatus()
// }
componentDidMount(){
    this.checkAuthStatus();
}
componentWillUnmount(){
    this.authListener && this.authListener();
    this.checkAuthStatus = undefined;
}
componentWillReceiveProps(props){
    if(props.bugReportSuccess === true){
        toast("Report Submitted Successfully")
        this.props.stuffActions.hideAlerts();
    }
    if(props.bugReportSuccess === false){
        toast.error("Error submitting bug report! Please try again later.")
        this.props.stuffActions.hideAlerts();
    }
    
}

  render() {
    const { visible } = this.state
    return (
        <div>
            <div className = 'center1'>
            <ToastContainer autoClose={2000}/>
                <div className = 'normal'>
                <Router>
                    <div as = {Menu}className ='ui raised segment' style={{position:"relative"}}>
                        <Button animated  id = 'toggleMenu' onClick={this.toggleVisibility}>
                            <Button.Content visible><Icon sixze='large' name = 'list ul'/></Button.Content>
                                        
                            <Button.Content hidden>
                                Menu
                            </Button.Content>
                    </Button>

                    <Popup 
                            trigger={

                                <Label as='a' image>
                                    {/* {this.props.nodeData && this.props.nodeData.length > 0 ? 
                                        <Label color='red' floating>
                                            22
                                        </Label>
                                        : null */}
                                    }
                                    <img alt="user" src={require('../assets/elliot.png')} />
                                    {this.state.userName ? (this.state.userName ): this.state.userEmail}
                                    <Label.Detail>×</Label.Detail>
                                </Label>
                                }
                            on='click'
                            
                            hideOnScroll
                            content = {
                                <div>
                                    {this.props.authenticated ? (
                                        <div>
                                            <Button.Group>
                                                <Button as={ Link }   to = {'/account'}>My Account </Button>
                                                    <Button.Or />
                                                <Button as={ Link } onClick ={this.handleSignOut} negative to = {'/account'}>Logout</Button>
                                            </Button.Group>
                                        </div>
                                        )
                                         :
                                        (
                                         <div>
                    
                                            <Button.Group>
                                                <Button as={ Link }  color='teal' to = {'/login'}>Sign Up</Button>
                                                    <Button.Or />
                                                <Button as={ Link } positive to = {'/login'}>Sign In</Button>
                                            </Button.Group>
                                        </div>

                                        
                                        )
                                     }

                                </div>
                            }
                    />
                    <Popup

                    />
                
                    </div>
                </Router>
                </div>
                
                    <Sidebar.Pushable>
                        <Sidebar id = 'sideNav' as={Menu} animation='overlay' direction='left' visible={visible}  vertical onClick={this.toggleVisibility}>
                        <Router>
                        <div>

                            <Menu.Item  as={ Link } to={this.props.link1}name=''>
                                    <Icon name='home' />
                                    Home
                            </Menu.Item>
                            {/* <Menu.Item  as={ Link } to={this.props.link2} name='dashboard'>
                                    <Icon name='dashboard' />
                                    Dashboard
                            </Menu.Item> */}
                            <Menu.Item as={ Link } to={this.props.link3} name='about'>
                                    <Icon name='info' />
                                    About
                            </Menu.Item>
                            <Menu.Item  disabled = {!this.props.authenticated}as={ Link } to={this.props.link4} name='account'>
                                    <Icon name='user' />
                                    Account
                            </Menu.Item>
                            <Menu.Item  disabled = {!this.props.authenticated}as={ Link } to={this.props.link5} name='networksettings'>
                                    <Icon name='settings' />
                                    Network Settings
                            </Menu.Item>
                            {(this.props.authenticated) ? 
                                (
                                    <Menu.Item   onClick ={this.handleSignOut}>
                                        <Icon name='log out' />
                                        Log Out
                                    </Menu.Item>):
                                (
                                    <Menu.Item as={ Link }  to={this.props.link6} name='login'>
                                        <Icon name='sign in' />
                                        Log In
                                    </Menu.Item>
                                )

                            }
                            <Menu.Item as={ 'a' } href={'https://docs.cbrdata.com'} target="_blank" name='docs'>
                                <i class="file alternate outline icon"/>
                                    API Documentation
                            </Menu.Item>                         


                        </div>                     
                        </Router>
                        </Sidebar>
                    <Sidebar.Pusher>
                        <Router>
                            <Switch>
                                <Route exact path = "/login" component = {Login} />
                                <Route exact path = "/" component = {Dashboard} />
                                <Route exact path = "/about" component = {About} />
                                <Route exact path = "/dashboard" component = {Dashboard} />
                                <Route exact path = "/account" component = {Account} />
                                <Route exact path = "/network/settings" component = {NetworkSettings} />
                                <Route component = {Whoops}/>
                            </Switch>
                        </Router>
                    </Sidebar.Pusher>
            </Sidebar.Pushable>

        
        </div>
        <footer id = "ft1">
        {this.props.authenticated ? (                
        <Modal  size='small' closeIcon trigger={<Label as = 'a' color='red'>Report a Bug</Label>}>
                    <Modal.Header>Report a Bug</Modal.Header>
                    <Modal.Content>
                        <p>
                            Please describe the issue with as much detail as possible.
                            
                        </p> 
                        <Form>
                        <Form.Field>
                            <Form.TextArea id ="bugReport" label='Detail'  placeholder='Please describe your issue in detail here..' />
                        </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>

                        <Button color='red' inverted onClick={this.submitBug}>
                            <Icon name='checkmark' /> Submit
                        </Button>
                    </Modal.Actions>
                </Modal> ):null}
        </footer>
    </div>

    )
  }

}

function mapStateToProps(state) {
    return {
        ...state.initState
    };
}

function mapDispatchToProps(dispatch) {
    return {
       stuffActions: bindActionCreators(stuffActions, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MainMenu);


// WEBPACK FOOTER //
// ./src/components/menu.js